/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { overflowEllipsis } from 'src/styles/mixins';

export const BranchTypeFilter = styled.div({
  minWidth: `${gridSize() * 16}px`,
  marginLeft: 0,
});

export const BranchTypeOptionWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  /* Tooltip used inside this element renders an extra "div" element.
     Because of which the default "ellipsis" styling from @atlaskit/select
     won't get applied. This fixes it. */
  '> div:last-child': {
    marginLeft: `${gridSize() * 4}px`,
    overflow: 'hidden',
  },
});

export const BranchTypeOptionPrefix = styled.div(
  {
    color: token('color.text.subtlest', colors.N100),
    font: token('font.body.UNSAFE_small'),
  },
  overflowEllipsis()
);
